import bbetti1 from "../img/Carousel/bbetti1.webp";
import bbetti2 from "../img/Carousel/bbetti2.webp";
import bbetti3 from "../img/Carousel/bbetti3.webp";

import bbetti5 from "../img/Carousel/bbetti5.webp";

import bbetti8 from "../img/Carousel/bbetti8.webp";



export const GalleryImages = [
  {
    imageDesktop: bbetti1,
    imageMobile: bbetti1,
    alt: "ceva",
  },
  {
    imageDesktop: bbetti2,
    imageMobile: bbetti2,
    alt: "ceva",
  },
  {
    imageDesktop: bbetti3,
    imageMobile: bbetti3,
    alt: "ceva",
  },

  {
    imageDesktop: bbetti5,
    imageMobile: bbetti5,
    alt: "ceva",
  },


  {
    imageDesktop: bbetti8,
    imageMobile: bbetti8,
    alt: "ceva",
  },


];
